<template>
    <div>
        <el-upload
        action="/wapi/base/upload"
        list-type="picture-card"
        :file-list="fileList"
        accept='image/*'
        :before-upload="handleBeforeUpload"
        :on-success="handleSuccess"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        >
             <i class="el-icon-plus"></i>
        </el-upload>

        <el-dialog v-model="imageVisible" size="tiny">
            <img width="100%" :src="imageUrl" alt="">
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: 'image-upload',
    props:{
        imgList: {
            type: Array,
            default: () => []
        },
        limit: {
            type: Number,
            default: 5
        }
    },
    data () {
        return {
            imageVisible: false,
            imageUrl: ''
        }
    },
    computed: {
        fileList(){
            return this.imgList.map(item => {
                return {
                    url: item,
                    name: item.split('/').pop()
                }
            })  
        }
    },
    methods: {
        handleBeforeUpload(file) {
            if (this.imgList.length >= this.limit) {
                this.$message.error('最多上传 ' + this.limit +'张图片');
                console.log(this.imgList)
                return false
            }
            const isLtM = file.size / 1024 / 1024 < 2;
            if (!isLtM) {
                this.$message.error('上传图片大小不能超过 2MB!');
                return false
            }
            return true
        },
        handleSuccess (file) {
            this.imgList.push(file.data)
        },
        handleRemove(file) {
            console.log(file)
            if (file.status === 'success') {
                 this.imgList.splice(this.imgList.indexOf(file.url), 1)
            }
           
        },
        handlePreview(file) {
            this.imageVisible = true;
            this.imageUrl = file.url
        },
    }
}
</script>


// WEBPACK FOOTER //
// ImageUpload.vue?606f4354